import React, {useEffect, useState} from 'react';
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Link, useLocation} from "react-router-dom";
import {CounterpartiesContacts, CounterpartiesCreateContacts} from "../../routesConstants";
import _ from "lodash";
import ApiSelect from "../../base/components/forms/apiSelect";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import BlockUi from "@availity/block-ui";
import ContactsForm from "./contactsForm";

const AllInfoContactsTab = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const { search } = useLocation();
  const params = new URLSearchParams(search)
  const [currentId, setCurrentId] = useState(params.get('id'))
  console.log("currentId",currentId)
  useEffect(() => {
    if(currentId){
      setLoading(true)
      setData()
      axios.get('/api/counterparty/contacts/'+currentId)
        .then(({data})=>{
          setData(data.contacts)
          window.history.pushState({}, null,
            `/counterparty/contacts?id=${currentId}${params.get('docId') ? `&docId=${params.get('docId')}` : ''}`)
        })
        .catch(sayError)
        .finally(()=> {
          setLoading(false)
        })
    }
  }, [currentId]);

  const onSubmit = (data) =>{
    setLoading(true)
    axios.patch('/api/counterparty/contacts/'+currentId, data)
      .then(({data})=>{
        if(data.nextId){
          setCurrentId(data.nextId)
        }else{
          window.alert('Информация успешно сохранена!')
        }
      })
      .finally(()=>setLoading(false))
  }
  return (
    <BlockUi blocking={loading}>
      <Portlet>
        <PortletHeader title={
          <div style={{minWidth:'20rem'}}>
            <ApiSelect
              value={currentId}
              label={'Клиент'}
              url={"/api/counterparty/contacts/searchInput"}
              cb={newVal => {
                setCurrentId(newVal);
                console.log('ask new', newVal)
              }}
            />
          </div>
        } toolbar={<PortletHeaderToolbar>
          <Link to={CounterpartiesCreateContacts} className="btn btn-sm btn-outline-primary">
            <i className="la la-plus"/>
            Добавить клиента
          </Link>
        </PortletHeaderToolbar>}/>
      </Portlet>
      {data && <ContactsForm data={data} onSubmit={onSubmit}/>}
    </BlockUi>

  );
};

export default AllInfoContactsTab;
